/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

// Vendor Requires
require('./vendor/slick.min.js');
require('./vendor/collapse');
require('./vendor/dropdown');
require('./vendor/modal');
require('./vendor/picturefill');
require('./vendor/tab');
require('./vendor/waypoint');
require('./vendor/waypoint-animate');
require("./vendor/jquery.countup.js");
require('./vendor/jquery.gridder.min');
require('./vendor/iframeResizer.min');

window.createCookie = require("./vendor/cookies");

//bootstrap components
//require('bootstrap/js/src/tab');

// App Requires
require('./app/sliders');
require('./app/iframes');
require('./app/primary-navigation');
require('./app/sticky-nav');
require('./app/alerts');
require('./app/jobstack');
require("./app/tabbed-dropdown.js");
require('./app/modals');
require('./app/newsroom');
require('./app/resources');
require('./app/to-top');
require('./app/countUp');
require('./app/content-expansion');
require('./app/city-geo-search');
require('./app/swiper-sliders');
require('./app/jobstack-animation');
require('./app/jobstack-landing-animation');
